module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAAExSURBVHja1JY9TgMxEIW/2XhDxEYEWiQEJWdAnICegqPRU3ARxDUiIWp+oiwh9sxQZJ2/2ouU19gaS+953rNsi7vTJyp6Ru8CAgRgBNSFuSOwCMD4/f7hQwaD4rs/f346C0AjVcXo9qYo+eLlFaAJQDBVWC6xr2/cHREhny4RAdip79fyfB3s5AQzAwgBwGPC5i3WtoDgeBeP4924qtPVNlit78LrIZ4SdAFjmvD2B5+3RezxEPCk61N0GWOchlUzxZBSoq7rqwrIfhVF5qz2AyqFzPk/HRy0RQHg+u4RkyGz+bII+bgZUkvcCCRVvDLUvJg90XVLICoEsEICqmC6JaDmVDjNcZkb23G0CzkAMSZF0qyP9yYKMAEugNPC5J/AW37RjrJdJa8j4FcO/lfxNwBleqag/5PB9AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/icons/nl.png
// module id = 1358
// module chunks = 0